export default __webpack_public_path__ + "static/media/living-Room_W623-OBLOGA-CD-PROFILI.0e468663.jpg";